{
  "abbreviations": {
    "house": "house",
    "hull": "hull",
    "appartement": "app."
  },
  "account": {
    "addingAddress": "Adding Address",
    "address": "Address",
    "addressDeleted": "Address deleted",
    "addressEditing": "Address Editing",
    "addresses": "Addresses",
    "addressInNativeAlphabet": "Address in native alphabet",
    "balance": "Balance",
    "customSenderTitle": "Custom sender",
    "customSenderDisabledTooltip": "Please fill out all required address fields",
    "customSenderDesc": "Enter sender details to replace default shipper",
    "demoMode": "Sample parcels",
    "demoModeOn": "Show",
    "demoModeOff": "Hide",
    "hiUser": "Hi, {{ fullName }}!",
    "personInfo": "Passport data is for customs clearance, required only for specific carriers",
    "settings": "Account Settings",
    "settingsUpdated": "Settings updated successfully",
    "theme": "Theme",
    "themeLight": "Light",
    "themeDark": "Dark",
    "themeSystem": "System",
    "userInfo": "User Info",
    "youWantDeleteAddress": "Are you sure that you want to delete this address?",
    "сustomID": "Passport data",
    "details": "Details",
    "preferences": "Preferences",
    "preferencesHint": "Saved to your account and used on every device.",
    "unitsHint": "Used for parcel weights and dimensions.",
    "notificationsHint": "How often we email you about parcel updates.",
    "unsavedChanges": "Unsaved changes",
    "discard": "Discard",
    "appearance": "Appearance",
    "appearanceHint": "Applies immediately on this device.",
    "demoModeDescription": "Show sample parcels in empty lists to see how the service works.",
    "security": "Security",
    "securityHint": "Change the password you sign in with.",
    "showPasswords": "Show passwords",
    "passwordUpdated": "Password updated",
    "memberSince": "Member since",
    "suite": "Suite",
    "copySuite": "Copy suite number"
  },
  "invoiceParse": {
    "parsing": "Reading the receipt…",
    "timeout": "Still reading…",
    "keepWaiting": "Keep waiting",
    "added": "Added {{count}} items from the receipt",
    "failed": "Could not read the receipt",
    "unavailable": "Receipt recognition is unavailable right now.",
    "tryAgain": "Try again",
    "tooLarge": "The receipt file must be smaller than 10 MB"
  },
  "declarationFile": {
    "drop": "Drag & drop a file here, or",
    "choose": "Choose file",
    "formatsSpreadsheet": "CSV, XLSX — declaration",
    "formatsReceipt": "JPG, PNG, WEBP, GIF, PDF up to 10 MB — receipt",
    "unsupported": "This file type is not supported"
  },
  "addressParse": {
    "inputLabel": "Recipient address",
    "inputPlaceholder": "John Doe, +1 555 123 4567, 123 Main St Apt 4, Austin, TX 78701, USA",
    "inputHint": "Paste the address as text: name, phone, street and house, city, postal code and country. The fields are recognized automatically.",
    "requiredAny": "Paste the address text or attach a photo",
    "attachPhoto": "Attach a photo",
    "dropPhoto": "Drag & drop a photo here, or",
    "photoFormats": "JPG, PNG, WEBP or GIF, up to 10 MB",
    "removePhoto": "Remove photo",
    "photoWrongFormat": "Only JPG, PNG, WEBP or GIF images are supported",
    "photoTooLarge": "The photo must be smaller than 10 MB",
    "recognize": "Recognize address",
    "enterManually": "Fill in manually",
    "parsing": "Recognizing the address…",
    "parsingCanLeave": "You can close this panel — if recognition succeeds, the address will appear in your list.",
    "parsingSlow": "This is taking longer than usual. You can keep waiting or fill in the address manually.",
    "timeoutTitle": "Recognition is still in progress",
    "keepWaiting": "Keep waiting",
    "reviewHint": "The address has been added to your list. Check every field before using it.",
    "useAddress": "Use this address",
    "discard": "Discard",
    "failedTitle": "Could not recognize the address",
    "failedGeneric": "Try rephrasing the text or fill in the address manually.",
    "failedValidation": "The recognized address did not pass validation:",
    "failedUnavailable": "Address recognition is temporarily unavailable. Please fill in the address manually.",
    "tryAgain": "Try again",
    "addedNotShown": "The address was recognized and added to your list."
  },
  "auth": {
    "alreadyHaveAnAccount": "Already have an account? Sign in",
    "changePassword": "Change password",
    "city": "City",
    "country": "Country",
    "dontHaveAccount": "Sign up",
    "email": "Email",
    "emailNotifications": "Email notifications",
    "originName": "Sender name",
    "originAddress1": "Sender address",
    "originState": "Sender state",
    "originCity": "Sender city",
    "originZipCode": "Sender zip code",
    "firstName": "First name",
    "flat": "Flat",
    "forgotPassword": "Forgot password",
    "fullName": "Full Name",
    "house": "House number",
    "hull": "Hull",
    "iAgreeTo": "I agree to ",
    "lastName": "Last name",
    "locale": "Language",
    "login": "Login",
    "newPassword": "New password",
    "newPasswordConfirm": "New password confirmation",
    "nextDeclaration": "Next declaration",
    "oldPassword": "Old password",
    "passportFullName": "Passport fullname",
    "passportIssued": "Passport issued by",
    "passportIssuedDate": "Passport issued date",
    "passportNumber": "Passport number",
    "passportSerial": "Passport number prefix",
    "password": "Password",
    "phone": "Phone",
    "postalCode": "Postal code",
    "taxId": "Tax ID",
    "rePassword": "Password confirmation",
    "registration": "Registration",
    "resetPassword": "Reset password",
    "signUp": "Sign Up",
    "stateOrRegion": {
      "US": "State",
      "other": "Region"
    },
    "startTypingAddress": "Start typing address",
    "street": "Street",
    "address1": "Address 1",
    "address2": "Address 2",
    "termsAndConditions": "Terms & Conditions",
    "units": "Units of measure",
    "signupToken": "Secret token",
    "yes": "Yes",
    "no": "No",
    "handling": "Unpacking policy"
  },
  "common": {
    "addAddress": "Add {{ word }} Address",
    "addCustomData": "Add custom data",
    "addDeclaration": "Add declaration",
    "addFilter": "Add filter",
    "addIdInformation": "Add ID information",
    "addToCart": "Add to cart",
    "another": "another",
    "areYouSureYouWantTo": "Are you sure you want to",
    "articleNotFound": "Article not found",
    "backwards": "Backwards",
    "back": "Back",
    "cancel": "Cancel",
    "resume": "Resume",
    "cancelAndDelete": "Cancel and Delete",
    "cancelConsolidation": "Cancel consolidation",
    "cancelRequest": "Cancel request",
    "change": "Change",
    "chooseParcels": "Choose shipments",
    "close": "Close",
    "comment": "Comment",
    "partnerTransferId": "Partner SB ID",
    "continue": "Continue",
    "continueWithProcessing": "Continue with processing",
    "continueToPaypal": "Continue to Paypal",
    "continueToPaymentMethod": "Continue to {{ paymentMethod }}",
    "continueToBalance": "Pay from balance",
    "noPaymentMethodsAvailable": "No payment methods available",
    "copiedSuccess": "Copied successfully",
    "creditCard": "Credit Card",
    "deleteAndLeave": "Delete and Leave",
    "deleteCartSuccess": "Outgoing parcel canceled",
    "deselect": "Deselect",
    "doNotLeave": "Do not leave",
    "edit": "Edit",
    "editCustomsData": "Edit customs data",
    "enter": "Enter",
    "field": "Field",
    "free": "{{currencySymbol}}0.00",
    "from": "from",
    "fullSize": "Full-size image",
    "goToOutgoing": "Go to outgoing",
    "hide": "Hide",
    "learnMore": "Learn more",
    "loading": "Loading",
    "loadingWithLabel": "Loading {{ word }}",
    "new": "new",
    "nextStep": "Next step",
    "pageNotFound": "Woops. Looks like this page doesn`t exist",
    "pay": "Pay",
    "payAll": "Pay all",
    "prohibitedGoodsFound": "Prohibited goods found",
    "remove": "Remove",
    "reviewAndPay": "Review and pay",
    "reviewAndPrepay": "Review and prepay",
    "save": "Save",
    "saveAndFinish": "Save and Confirm",
    "saveAndLeave": "Save and Leave",
    "saveChanges": "Save changes",
    "search": "Search",
    "selectAll": "Select all",
    "selectYear": "Select year",
    "send": "Send",
    "sentIn": "Sent in",
    "sendTheCart": "Send cart",
    "show": "Show",
    "show5More": "Show 5 more",
    "state": "State",
    "takeMeBack": "Take me back to homepage",
    "to": "to",
    "undo": "Undo",
    "yes": "Yes",
    "no": "No",
    "copiedToClipboard": "Copied to clipboard",
    "csvShipments": "Shipments in CSV",
    "processBankCard": "Process Bank Card",
    "processPaypal": "Process Paypal",
    "processStripe": "Continue to Stripe",
    "processOverpay": "Process Overpay",
    "stripe": "Stripe",
    "stripePay": "Pay {{amount}} with Stripe",
    "stripeEditAmount": "Edit amount",
    "stripeLoading": "Loading secure Stripe payment form",
    "stripeProcessing": "Your Stripe payment is still processing. We will finish it automatically when it is ready.",
    "stripeInvalidReturn": "We could not verify the returned Stripe payment.",
    "stripePaymentFailed": "Stripe could not complete the payment. Please try again.",
    "stripePaymentSucceeded": "Stripe payment completed successfully.",
    "overpay": "Overpay SBP",
    "options": "Options",
    "assignComment": "Assign a comment"
  },
  "dashboard": {
    "coupons": "Сoupons",
    "couponsAdded": "added",
    "new": "New",
    "newCoupons": "{{ number }} new coupons ",
    "newDelivery": "New delivery method",
    "newUpdate": "В разработке:",
    "online": "online",
    "qa": "Popular questions",
    "sent": "Sent",
    "waiting": "Waiting for an action",
    "warehouseAddress": "Warehouse Address",
    "warehouseClose": "CLOSE",
    "warehouseClosing": "Closing in",
    "warehouseIs": "Warehouse is",
    "warehouseOpen": "OPEN",
    "warehouseOpening": "Opening in",
    "yourAddress": "Your USA address",
    "filterKnowledgeBase": "Find information in knowledge base",
    "noResultsFound": "No results found"
  },
  "paymentInfoConfirmation": {
    "confirmationTitle": "Confirm declared value!",
    "willBeSent": "Package for",
    "addressPrefix": "at",
    "shipmentTotal": "Shipment's customs value is",
    "confirmationHint": "Please confirm the details are correct. You will not be able to make any changes after the payment",
    "cancel": "Review data",
    "confirm": "Confirm"
  },
  "dev": {
    "buttons": "Buttons",
    "checkboxes": "Checkboxes",
    "datepicker": "Datepicker",
    "icons": "Icons",
    "images": "Images",
    "inputs": "Inputs",
    "openRightPanel": "Open right panel",
    "pageInDev": "Page in development",
    "pages": "Pages",
    "rightPanel": "Right panel",
    "selects": "Selects",
    "toasts": "Toasts",
    "tooltips": "Tooltips"
  },
  "emailNotifications": {
    "eachEvent": "After each event",
    "oncePerDay": "Once per day",
    "oncePerWeek": "Once per week"
  },
  "error": {
    "atLeastOne": "At least one field must be selected",
    "dateLessThanCurrent": "Date should be less than current one",
    "englishOnly": "Please, use English only",
    "englishAndCyrillicOnly": "Please, use English or Cyrillic only",
    "validHouseNumber": "Please, use letters, numbers and / only",
    "hasLowercase": "The string must contain at least 1 lowercase alphabetical character",
    "hasNumeric": "The string must contain at least 1 numeric character",
    "hasUppercase": "The string must contain at least 1 uppercase alphabetical character",
    "hasSymbol": "The string must contain at least 1 symbol character",
    "hasAlphabetical": "The string must contain at least 1 alphabetical character",
    "invalid": "Invalid {{ field }}",
    "invalidRePass": "Passwords don't match",
    "numberLonger": "{{ field }} must have {{ length }} digits",
    "numberWithSingleLetter": "The string can contain one letter after the number, for example: \"23\" or \"2B\"",
    "onlyNumber": "Only digits",
    "passMatch": "Passwords don't match",
    "phoneNumberIsNotFully": "Phone number is not fully entered",
    "required": "{{ field }} is required",
    "requiredField": "This field is required",
    "someFieldsHasErrors": "Some fields has errors",
    "stringLonger": "The string must contain at least {{ length }} characters",
    "stringShorter": "The string must be less than {{ length }} characters",
    "whiteSpaces": "The string must not contain whitespaces",
    "withAlphabetic": "The string must contain at least one alphabetic character",
    "paymentWasCanceled": "The payment was canceled",
    "creditCard": {
      "wrongExpirationFormat": "Expiration date should have the format: MM/YYYY"
    },
    "duplicateRowCustomData": "There are duplicate rows in the custom data. Please check the highlighted fields and ensure each entry is unique.",
    "requestTimeout": "The server took too long to respond. Please try again."
  },
  "errorPasswordSignup": {
    "length": "Minimum {{ length }} characters",
    "numeric": "At least 1 numeric character",
    "alphabetical": "At least 1 alphabetical character",
    "symbol": "At least 1 symbol character",
    "whiteSpaces": "No whitespaces"
  },
  "appError": {
    "title": "Something went wrong",
    "description": "An unexpected error occurred and the page needs to be reloaded.",
    "reload": "Reload page"
  },
  "imageViewer": {
    "fullscreen": "Full Screen",
    "next": "Show next image",
    "prev": "Show prev image"
  },
  "inbound": {
    "addShipment": "Add shipment",
    "shipFromAddresses": "Ship-from addresses",
    "importCsv": "Import from CSV",
    "tabs": {
      "shipments": "Shipments"
    },
    "emptyList": "You have no inbound shipments yet",
    "shipmentTitle": "Inbound shipment",
    "newShipmentTitle": "New inbound shipment",
    "placeholderIcon": "Placeholder icon - 0 inbound shipments",
    "addAddress": "+ Add new address",
    "deleteConfirmTitle": "Delete shipment",
    "deleteConfirmText": "This inbound shipment will be permanently deleted. Continue?",
    "form": {
      "address": "Ship from",
      "weight": "Weight",
      "height": "Height",
      "length": "Length",
      "width": "Width",
      "comment": "Comment",
      "packageTitle": "Package {{number}}",
      "addPackage": "+ Add package",
      "removePackage": "Remove package"
    },
    "list": {
      "packages": "Packages: {{amount}}"
    },
    "status": {
      "draft": "Draft",
      "estimated": "Quote ready",
      "labeled": "Label created"
    },
    "quote": {
      "title": "Shipping quotes",
      "getQuote": "Get quotes",
      "buyLabel": "Buy label",
      "shipping": "Shipping",
      "deliveryDays": "Delivery: {{amount}} d.",
      "volumetricExtra": "Volumetric surcharge",
      "volumetricWarning": "The carrier will bill this parcel by volumetric weight.",
      "staleOnEdit": "Saving these changes will discard the current quote.",
      "expiredNote": "Shipping quotes expire. Get fresh quotes to buy a label.",
      "noRates": "No shipping rates are available for this shipment."
    },
    "label": {
      "title": "Shipping label",
      "trackingNumber": "Tracking number",
      "download": "Download label",
      "cost": "Label cost",
      "insurance": "Insurance",
      "totalCharged": "Total charged",
      "packagesTitle": "Package labels",
      "cancel": "Cancel label",
      "cancelConfirmTitle": "Cancel label",
      "cancelConfirmText": "The purchased label will be voided and can no longer be used. Continue?"
    },
    "parse": {
      "open": "Paste packages",
      "title": "Packages from text",
      "description": "Describe each package in its own paragraph: your internal ID, weight and dimensions, the recipient's address, and the items with quantity and price. The shipment is created for the ship-from address you pick.",
      "placeholder": "Order A-100: 2 kg, 30x20x10 cm.\nJane Doe, 1100 Congress Ave, Austin, TX 78701, US, +1 512 555 0100.\nSneakers 1 pc $120, socks 2 pcs $10.",
      "submit": "Create shipment",
      "parsing": "Recognizing packages…",
      "parsingHint": "This usually takes under a minute.",
      "timeout": "Still working…",
      "keepWaiting": "Keep waiting",
      "success": "Shipment created",
      "failedTitle": "Could not create the shipment",
      "failedValidation": "Fix these and try again:",
      "unavailable": "Recognition is unavailable right now. Use Import from CSV or add the shipment manually.",
      "tryAgain": "Try again"
    },
    "import": {
      "title": "Import shipment from CSV",
      "description": "One CSV file creates one inbound shipment; each row is one package. Required columns: weight, height, length, width. Optional: customer_comment.",
      "selectFile": "Choose CSV file",
      "submit": "Import",
      "downloadExample": "Download example CSV",
      "success": "Shipment imported",
      "wrongFormat": "The file must be a .csv",
      "tooLarge": "File is too large (max 5 MB)",
      "moreErrors": "…and more errors: {{amount}}"
    },
    "addresses": {
      "addAddress": "Add address",
      "search": "Search by name or address",
      "notFound": "No ship-from addresses found",
      "empty": "You have no ship-from addresses yet",
      "addingTitle": "New ship-from address",
      "editingTitle": "Edit ship-from address",
      "name": "Full name",
      "phone": "Phone",
      "addressLine1": "Address line 1",
      "addressLine2": "Address line 2",
      "city": "City",
      "state": "State",
      "zipCode": "ZIP code"
    }
  },
  "locales": {
    "en": "English",
    "ru": "Russian"
  },
  "localesNative": {
    "en": "English",
    "ru": "Русский"
  },
  "notifications": {
    "eachEvent": "After each event",
    "oncePerDay": "Once per day",
    "oncePerWeek": "Once per week"
  },
  "mailbox": {
    "copyAddress": "Copy address",
    "copyField": "Copy {{field}}",
    "fields": {
      "name": "Name",
      "addressLine1": "Address line 1",
      "addressLine2": "Address line 2",
      "city": "City",
      "zip": "ZIP",
      "phone": "Phone"
    },
    "suite": "Suite {{suite}}",
    "suiteNote": "{{suite}} is your personal number. Put it in Address line 2, otherwise the parcel can't be linked to your account."
  },
  "pages": {
    "404": "404",
    "terms": "Terms & Conditions",
    "privacy": "Privacy Policy",
    "refund-policy": "Refund & Cancellation Policy",
    "prohibited-items": "Prohibited Items",
    "account": "Account",
    "settings": "Settings",
    "clients": "Clients",
    "containers": "Containers",
    "history": "Shipped",
    "logout": "Logout",
    "orders": "Orders",
    "outgoing": "Outgoing",
    "parcels": "Shipments",
    "password-change": "Change password",
    "password-reset": "Forgot password",
    "shipping": "Parcel figuration",
    "signin": "Login",
    "signout": "Sign Out",
    "signup": "Registration",
    "storage": "Storage",
    "expected": "Incoming",
    "inbound": "Inbound",
    "books": "Financials",
    "tools": "Tools",
    "shopify": "Shopify",
    "mailbox": "Mailboxes",
    "support": "Support",
    "home": "Home",
    "recipients": "Recipients",
    "utilities": "Utilities"
  },
  "containers": {
    "emptyList": "You don't have any containers yet",
    "emptyShipments": "No shipments in this container yet",
    "weight": "Weight",
    "dimensions": "Dimensions",
    "created": "Created",
    "state": {
      "open": "Open",
      "closed": "Closed"
    }
  },
  "parcels": {
    "additionalInfoMessage": "Please let us know any additional info we need to know",
    "additionalOptions": "Additional options",
    "approximateDeliveryCost": "Approximate delivery cost",
    "cancel": "cancel",
    "cancelConsolidationSuccess": "Cancel consolidation successfully",
    "cancelPacking": "Cancel packing",
    "cancelPackingMessage": "All your parcels will be returned to the storage section",
    "commentsInProcess": "Comment in process",
    "confirmCancelPacking": "Yes, cancel packing",
    "continuePacking": "No, continue with packing",
    "costPerKg": "Cost per kg",
    "createdAt": "Created at",
    "creditCardNotAvailable": "Credit Card payment not available in the moment",
    "customsData": "Customs data",
    "customsDeclarations": "Customs declarations",
    "changingAddress": "Changing address",
    "dateReceived": "Date received",
    "daysLeft": "{{ days }} days left",
    "currentParcelGuide": {
      "backToList": "Back to the list",
      "openDetails": "Open parcel details",
      "steps": {
        "address": "Choose the shipping address",
        "checkout": "Press Continue below to review and pay",
        "customs": "Fill in the customs declaration",
        "method": "Choose the shipping method",
        "packing": "Choose packing",
        "review": "Check the shipments included in the parcel"
      },
      "subtitle": "Your storage shipments are already in this parcel. Complete these steps to send it.",
      "title": "Parcel {{sku}} is being assembled",
      "toggle": "How do I finish my parcel?"
    },
    "demo": {
      "actionHint": "This is a sample parcel — actions are disabled. They will work once your real package arrives at the warehouse.",
      "badge": "Sample",
      "cta": {
        "addressLabel": "Your address ({{country}})",
        "declareExpected": "Declare an expected parcel",
        "subtitle": "Order to our warehouse address. We'll receive, weigh, and photograph your package — and it will show up in this list, usually within 24 hours of arriving at the warehouse.",
        "whatToShip": "What can be shipped"
      },
      "expectedSubtitle": "These are samples. Parcels you declare appear here until they arrive at the warehouse — click a row to open the parcel form.",
      "expectedTitle": "Sample expected parcels — this is what yours will look like",
      "hide": "Hide samples",
      "hideConfirmation": "Sample parcels are hidden. You can turn them back on in the account settings.",
      "itemsSubtitle": "These are samples. Items registered at the warehouse appear here — click a row to see the item card.",
      "itemsTitle": "Sample items — this is what your parcel contents will look like",
      "outgoingSubtitle": "These are samples. Consolidations being packed and ready for payment appear here — click a row to see the parcel card.",
      "outgoingTitle": "Sample outgoing parcels — this is what yours will look like",
      "subtitle": "These are samples. When a package arrives at the warehouse it will show up here — click a row to see the parcel card.",
      "title": "Sample parcels — this is what yours will look like"
    },
    "delivery": "Delivery",
    "description": "Description",
    "details": "Details",
    "empty": "You haven`t packages for sending for now",
    "emptyHistory": "Once your parcel is paid and shipped, a record of it will be stored here for reference",
    "searchByTrackingNumber": "Search by tracking number",
    "searchBySku": "Search by consolidation SKU",
    "historyForSelectedYear": "History for {{ selectedYear }} year",
    "inProgress": "In progress",
    "insurance": "Insurance",
    "insuranceMessage": "We provide our clients with our own insurance to cover against most damage occuring in transit.",
    "itemDeleted": "Item deleted",
    "item": "item",
    "items": "items",
    "leaveComment": "Leave your comment here",
    "loadMore": "Load more",
    "makePaymentWithin": "Make payment within",
    "notFinished": "Not finished",
    "notSelectedYet": "No shipper",
    "numberNotFound": "number not found",
    "packOptionsSaved": "Pack options are saved for {{ number }}",
    "package": "Package",
    "excessPackagesIncluded": "Excess shipments",
    "packagesIncluded": "Incoming shipments included",
    "shipments": "Shipments",
    "packing": "Packing",
    "packingGrade": "Packing method",
    "packingGradeAndOptions": "Packing",
    "packingServiceRequests": "Packing service requests",
    "packingOptions": "Packing options",
    "packingInGenitive": "packing",
    "paid": "paid",
    "paidUsing": "Paid using",
    "parcelInformation": "Parcel information",
    "parcelsInformation": "Parcels information",
    "parcelWeight": "Parcel weight",
    "parcels": "parcels",
    "parcel": "parcel",
    "placeholderIcon": "Placeholder Icon - 0 parcels",
    "paymentMethod": "Payment method",
    "price": "Price",
    "priceInfo": "Price information",
    "prohobitedGoods": "Prohobited goods",
    "prohobitedGoodsWarning": "There was prohobited goods found at your parcel/parcels. You can check photos of them bellow. Please select what do you like to do with them.",
    "putYourComment": "Put your comment",
    "quantity": "Quantity",
    "receivedDate": "Received at",
    "requestCanceled": "Request canceled",
    "returnToStore": "Return to store",
    "search": {
      "applyFilter": "Apply filter",
      "date": "Date",
      "dateEnd": "Date end",
      "dateFrom": "From",
      "dateRangeError": "Enter a valid date, the end date can not be earlier than the start date",
      "dateStart": "Date start",
      "dateTill": "Till",
      "dismiss": "Dismiss",
      "exactDates": "Exact Dates",
      "filterByTransactionNumber": "Search for tracking number or shipment comment",
      "filterByTrackingNumber": "Search for tracking number",
      "found": "Parcels found",
      "inventoryItemsFound": "Inventory items found",
      "items": "Items",
      "lastMonth": "Last month",
      "lastWeek": "Last week",
      "resetFilter": "Reset filter",
      "selectDate": "Date received:",
      "selectShop": "Select shop:",
      "selectCustoms": "Customs declaration:",
      "customs": "Customs",
      "withCustoms": "With declaration",
      "withoutCustoms": "Without declaration",
      "selectComment": "Enter comment:",
      "selectOrder": "Enter order number:",
      "searchMode": "Search mode",
      "shipments": "Shipments",
      "shop": "Shop",
      "specifyWeight": "Specify parcel weight:",
      "today": "Today",
      "tools": "Tools",
      "tryAnotherSearch": "Try another search",
      "weight": "Weight",
      "yesterday": "Yesterday",
      "comment": "Comment",
      "order": "Order"
    },
    "itemsView": {
      "viewMode": "View mode",
      "rowsView": "List",
      "tilesView": "Tiles",
      "tileColumns": "Tiles per row",
      "nextPhoto": "Next photo"
    },
    "selectedAmount": "Quantity selected",
    "shipmentNotSend": "Unavailable for sending - service request pending",
    "shipmentProhibited": "Phohibited for sending. Please contact support team.",
    "shippingAddress": "Shipping address",
    "shippingMethod": "Shipping method",
    "startSelectingForSending": "Select parcels in storage to create an outgoing parcel request",
    "total": "{{ amount }} Total",
    "totalLabel": "Total",
    "totalPackingCost": "Total packing cost",
    "totalPrice": "Total price:",
    "totalWeight": "Total weight:",
    "vendor": "Vendor",
    "waitingForInformation": "Waiting for more information",
    "waitingForPayment": "Waiting for payment",
    "paymentPaid": "Paid",
    "wantToSend": "Want to send",
    "warehouseComment": "Warehouse comment",
    "week": "Week {{ numberWeek }}",
    "weight": "Weight",
    "whatToCheck": "Please let us know what you would like us to check",
    "whenPackageSentExtra": "When package is sent extra funds will be returned to your account for later use",
    "youDontAnyOutgoingParcels": "You don’t have any outgoing parcels",
    "youNotFinishedProcessing": "You have an outgoing parcel pending. Please complete or cancel that request before sending other shipments.",
    "balance": "Current balance",
    "negativeBalanceTooltip": "You have a negative balance. Your bill will be increased by this amount.",
    "positiveBalanceTooltip": "You have a positive balance. Your bill will be reduced by this amount.",
    "commissionFeeLabel": "Payment processing fee ({{fee}}%)",
    "totalToPay": "Total to pay",
    "paymentByBalance": "Pay only from balance",
    "state": {
      "paid": "Shipping out",
      "pending": "Packing pending",
      "claimed_for_packing": "Packing in progress",
      "picked": "Packing in progress",
      "claimed": "Packing in progress",
      "waiting_for_task": "Packing pending"
    },
    "paidDate": "Paid",
    "createdDate": "Created",
    "brutto": "brutto",
    "shipped": "Shipped",
    "moreDetails": "More details",
    "notFinishedShowRequiredFieldsError": "Please fill out all required fields"
  },
  "serviceRequests": {
    "title": "Service requests",
    "submit": "Request",
    "unprocessed": "Service request is pending",
    "additionalPhotos": {
      "message": "Service requests are completed within 24 hours",
      "paragraph": "In case you need to know more about the product you have just purchased, we will provide detailed photographs of shipment's contents.",
      "processed": "Photos are ready",
      "submit": "Request photos",
      "title": "Additional photos",
      "unprocessed": "Service request is pending"
    },
    "check": "Check",
    "done": "Completed",
    "packOptions": {
      "costHeading": "Additional packing cost",
      "heading": "Pre-select options",
      "paragraph": "Options applied to individual shipments will have higher priority and will override bulk options applied to entire outgoing parcel ",
      "submit": "Save options",
      "title": "Pack options",
      "tooltip": "tooltip"
    },
    "inventory": {
      "title": "Inventory"
    },
    "removeFromConsolidation": {
      "actionText": "Remove from consolidation"
    },
    "placeholderComment": "Please let us know if there is anything specific you would like to verify.",
    "powerCheck": {
      "message": "Service requests are completed within 24 hours",
      "paragraph": "For you we could check if electrical devices works and take a short video of power check in process",
      "processed": "Power check is done",
      "submit": "Check power",
      "title": "Power check",
      "unprocessed": "Power check in the process..."
    },
    "processTime": "Service requests are completed within 24 hours",
    "requestCost": "Request cost",
    "returnPackage": {
      "title": "Return to the store",
      "writeUsFirstPart": "You can write us at: ",
      "writeUsSecondPart": "to return your package to the store"
    },
    "serviceByInstruction": {
      "message": "Service requests are completed within 24 hours",
      "paragraph": "Power-on verification, measurements, manufacturer defects. We will provide video of the process and results",
      "processed": "Completed",
      "submit": "Send instructions",
      "title": "Service by instruction",
      "unprocessed": "Service request is pending"
    },
    "requestInventoryShipment": {
      "title": "Request inventory",
      "submit": "Request",
      "paragraph": "Inventory service provides complete control over products in your incoming shipments.",
      "paragraph2": "Each item is registered individually, barcoded and photographed. Items from different shipments then can be consolidated and packed together.",
      "cost": "2.00",
      "costSuffix": " + {{currencySymbol}}0.2/item",
      "unprocessed": "Service request is pending"
    },
    "requestTransferShipment": {
      "title": "Transfer",
      "submit": "Request",
      "paragraph": "Please provide your partner's SB ID to request a shipment transfer. A code will be generated that will be required to activate the shipment on the receivers end.",
      "paragraphClientTransferring": "Please provide a transfer code to accept this shipment.",
      "processed": "Requested",
      "transferPartnerId": "Partner's SB ID",
      "transferPartnerCode": "Transfer code",
      "transferCompleteCode": "Transfer complete"
    },
    "states": {
      "canceled": "Canceled",
      "declined": "Declined",
      "pending_moderation": "Pending",
      "pending_translation": "Pending",
      "processed": "Completed",
      "requested": "Completed",
      "translated": "Pending",
      "unprocessed": "Pending",
      "warehouse_requested": "Pending"
    }
  },
  "shipping": {
    "additionalСost": "Additional package cost",
    "address": "Address",
    "allPackages": "All packages",
    "amountOfItemsInCart": "Items",
    "cancelSending": "Cancel sending",
    "cancellation": "Cancellation",
    "cartDetails": "Cart details",
    "checkCustomData": "Customs declaration",
    "customData": "Customs Declaration",
    "delivery": "Shipping method",
    "deliveryAndPacking": "Shipping and Packing",
    "deliveryCost": "Estimated brutto shipping cost",
    "done": "Done",
    "payAfterPacking": "Pay after packing",
    "includingInsurance": "Including insurance",
    "insurance": "Insurance",
    "leave": "Leave and cancel",
    "leaveProcessing": "Leave processing",
    "optionsForAllPackages": "Options for all packages",
    "optionsForIndividualItems": "Individual options and services",
    "packing": "Packing",
    "packingСost": "Packing cost",
    "expectedСost": "Expected cost",
    "totalExpectedСost": "Total expected cost",
    "services": "Services",
    "payInAdvance": "Pay in advance",
    "payInAdvanceHelpMessage": "When parcel is packed, shipping cost difference will be debited/credited to your account. It will be automatically applied to the payment for your next parcel.",
    "payInAdvanceMessage": "Pre-pay shipping based on brutto weight and have the parcel processed right after it's packed",
    "price": "Price",
    "remain": "Remain and finish",
    "selectAdditional": "Primary options for",
    "selectAdditionalShipment": "Options for",
    "selectAddress": "Select shipment address",
    "selectDelivery": "Select shipping method",
    "selectPacking": "Select packing method",
    "steps": {
      "1": "Step 1 - Address",
      "2": "Step 2 - Delivery",
      "3": "Step 3 - Packing",
      "4": "Step 4 - Additional options",
      "5": "Step 5 - Customs data",
      "6": "Final step - Summary"
    },
    "summary": "Summary",
    "total": "Total",
    "totalCostDescription": "Cost of options and services applied to this outgoing parcel or it's individual shipments",
    "totalСost": "Total packing cost",
    "youAreLeaving": "You are leaving",
    "addonsCost": "Addons cost",
    "serviceAndOptions": "Service and Options",
    "addUrlLinks": "Add URL links",
    "totalRows": "rows",
    "singularCustomsSummary": "line",
    "pluralCustomsSummary": "lines",
    "quantityCustomsSummary": "Q-ty",
    "customsSummaryValue": "value",
    "noHsCodeFound": "Description not found",
    "noAddressFound": "No address found"
  },
  "units": {
    "kg": {
      "title": "kg / cm",
      "primaryShort": "kg",
      "secondaryShort": "cm"
    },
    "lbs": {
      "title": "lbs / inch",
      "primaryShort": "lbs",
      "secondaryShort": "inch"
    }
  },
  "handling": {
    "processWhole": {
      "title": "Process whole shipments",
      "description": "The parcel is registered as one unit and stays packed."
    },
    "processIndividual": {
      "title": "Process individual items",
      "description": "The parcel is opened and each item is registered separately, so you can ship some items or combine items from different parcels."
    }
  },
  "popup": {
    "notFinished": {
      "deletionConfirmation": "Are you sure you wish to delete this item?"
    }
  },
  "conjugation": {
    "packages": {
      "1": "One package",
      "2": "Two packages",
      "3": "Three packages",
      "4": "Four packages",
      "5": "Five packages",
      "6": "Six packages",
      "7": "Seven packages",
      "8": "Eight packages",
      "9": "Nine packages",
      "10": "Ten packages",
      "nth": "{{ count }} packages"
    }
  },
  "purchase": {
    "creditCard": {
      "billingAddress": "Billing Address",
      "articles": {
        "refundPolicy": "Refund Policy",
        "privacyPolicy": "Privacy Policy",
        "termsOfService": "Terms of Service",
        "cancellations": "Cancellations",
        "contact": "Contact"
      },
      "countryRegion": "Country/Region",
      "name": "Name on card",
      "number": "Card number",
      "expiration": "Expiration (MM/YYYY)",
      "cvv": "Security Code",
      "address": "Address",
      "address2": "Apartment, suite, etc. (optional)",
      "state": "State",
      "zipCode": "ZIP code",
      "cvvTooltip": "3-digit security code usually found on the back of your card. American Express cards have a 4-digit code located on the front.",
      "secureNotice": "All transactions are secure and encrypted."
    }
  },
  "tooltips": {
    "shipmentIsBox": "This shipment is a box",
    "shipmentIsBag": "This shipment is a bag",
    "shipmentHasCustomsDeclarations": "Customs declaration attached",
    "excessMarker": "Some items returned to storage"
  },
  "tools": {
    "putAway": "Put Away",
    "putAwaySuccess": "Put away request was successful",
    "printUsers": "Print Users",
    "createPrintUser": "Create Print User",
    "editPrintUser": "Edit Print User",
    "viewPrintUser": "Print User",
    "deleteConfirmation": "Are you sure you want to delete this print user?",
    "changePassword": "Change Password",
    "email": "Email",
    "uid": "UID",
    "password": "Password",
    "passwordConfirmation": "Password Confirmation",
    "createdAt": "Created At",
    "deletePrintUser": "Delete",
    "noPrintUsers": "No external print users"
  },
  "books": {
    "transactions": "Transactions",
    "recipients": "Destinations",
    "searchRecipients": "Search for name or address",
    "notFoundRecipients": "Not found recipients",
    "importAddresses": "Import from CSV",
    "importAddressesSuccess": "Addresses imported: {{amount}}",
    "importAddressesWrongFormat": "The file must be a .csv",
    "importAddressesTooLarge": "File is too large (max 5 MB)",
    "importAddressesDrop": "Drag & drop a CSV file here, or",
    "importAddressesChooseFile": "Choose file",
    "importAddressesFormats": "CSV, up to 5 MB",
    "importAddressesDownloadExample": "Download example CSV",
    "importAddressesMoreErrors": "…and more errors: {{amount}}",
    "passports": {
      "title": "Passports",
      "searchPassports": "Search by name",
      "addPassport": "Add passport",
      "viewPassport": "Passport details",
      "create": "Create passport",
      "fullName": "Full name",
      "serial": "Serial",
      "number": "Number",
      "issuedBy": "Issued by",
      "registration": "Registration address",
      "taxId": "Tax ID (INN)",
      "issuedDate": "Issued date",
      "dateOfBirth": "Date of birth",
      "notFound": "No passports found"
    },
    "addFunds": "Add funds",
    "addFundsBtnTitle": "Add funds via bank card",
    "addFundsPanel": {
      "chargeBankCard": "Charge a bank card",
      "successfulTransactions": "Successful transaction for ${{ amount }}",
      "chargePaypal": "Add funds with Paypal",
      "chargeStripe": "Add funds with Stripe",
      "chargeOverpay": "Add funds with Overpay SBP",
      "addAmountToBalance": "Add amount to balance",
      "paymentProcessingFee": "Payment Processing Fee {{feePercent}}%"
    },
    "voucherFundsPanel": {
      "panelTitle": "Balance vouchers",
      "titleCreate": "Create",
      "titleRedeem": "Redeem",
      "titleLog": "Log"
    },
    "usdt": {
      "panelTitle": "Add funds with USDT",
      "recentDeposits": "Recent deposits",
      "noDeposits": "No deposits yet",
      "successfulTransactions": "Deposit of {{amount}} USDT received. Your balance has been updated."
    },
    "errorAmountRangeAddFunds": "Amount should be in the range from {{currencySymbol}}{{min}} to {{currencySymbol}}{{max}}",
    "search": {
      "filterByDescription": "Search for description",
      "filterByAmount": "Amount",
      "tryAnotherSearch": "Try another search",
      "found": "Transactions found"
    },
    "bankCard": {
      "title": "Bank Card",
      "successfulTransactions": "Successful transaction for {{currencySymbol}}{{ amount }}"
    },
    "paypal": {
      "successfulTransactions": "Successful transaction for {{currencySymbol}}{{ amount }}"
    },
    "stripe": {
      "title": "Stripe",
      "successfulTransactions": "Successful transaction for {{currencySymbol}}{{ amount }}"
    },
    "overpay": {
      "title": "Overpay SBP",
      "successfulTransactions": "Successful transaction for ${{ amount }}"
    },
    "voucher": {
      "title": "Balance Voucher",
      "successfulTransactions": "Successful transaction for {{currencySymbol}}{{ amount }}",
      "successfulRedeemTransactions": "Successful redeem for code ${{ code }}",
      "createVoucher": "Create voucher"
    }
  },
  "usdtDeposit": {
    "addToBalance": "Add to balance",
    "fee": "Processing fee",
    "feePercent": "Processing fee ({{percent}}%)",
    "feePercentMin": "Processing fee ({{percent}}%, min {{fixed}} USDT)",
    "feeValuePercentMin": "{{percent}}%, min {{fixed}} USDT",
    "sendAtLeast": "Send at least",
    "minAmount": "Minimum deposit",
    "checkPayment": "I've paid — check payment",
    "checkingUntil": "Checking for your transfer until {{time}}.",
    "checkAgainAt": "You can check again at {{time}}.",
    "received": "{{amount}} already credited for this payment.",
    "completing": "Payment received, completing…",
    "warnings": {
      "network": "Send USDT on the TRC-20 (Tron) network only. Transfers on other networks are not credited.",
      "minAmount": "Transfers below {{min}} are not credited automatically — contact support if you sent less.",
      "permanent": "This address is yours permanently: send any amount at any time. Each transfer is credited separately once it is confirmed on the blockchain."
    },
    "retry": "Retry",
    "payFailed": "Your deposit was credited, but the payment could not be completed.",
    "stillShort": "Your deposit was credited, but your balance still does not cover the total. Send the remaining amount to the same address.",
    "loadFailed": "Could not load your deposit address.",
    "copyAddress": "Copy address",
    "viewTx": "View transaction on Tronscan"
  },
  "telegramLink": {
    "title": "Telegram",
    "intro": "Get updates in Telegram when a package arrives at the warehouse, when your consolidation is packed and when it ships.",
    "statusNotLinked": "Not linked",
    "statusLinked": "Linked",
    "statusPending": "Waiting for confirmation",
    "statusExpired": "Link expired",
    "linkedOn": "Linked on {{ date }}",
    "addedBy": "Added by {{ name }}",
    "open": "Open Telegram",
    "expiresIn": "The link expires in {{ time }}",
    "expired": "The link has expired. Get a new one to continue.",
    "newLink": "Get a new link",
    "loadFailed": "Could not load the Telegram link status.",
    "retry": "Retry",
    "private": {
      "title": "Personal chat",
      "hint": "Updates arrive in your own chat with the bot.",
      "link": "Link chat",
      "unlink": "Unlink chat",
      "pendingHint": "Open the link where you use Telegram, or scan the code with your phone, then press Start in the chat with {{ bot }}."
    },
    "group": {
      "title": "Group",
      "hint": "Add the bot to a group, for example your team's chat, and updates are posted there too.",
      "link": "Link group",
      "unlink": "Unlink group",
      "pendingHint": "Open the link where you use Telegram, or scan the code with your phone, then choose a group. Telegram adds {{ bot }} to it and links it.",
      "unlinkHint": "After unlinking, the bot stops posting to the group but stays in it until you remove it."
    }
  },
  "sms": {
    "tab": "SMS",
    "title": "SMS number",
    "subtitle": "A US phone number that receives text messages for sign-ups and verification codes. Receive-only: no sending, no calls, no MMS.",
    "pricePerMonth": "{{price}} / month",
    "howItWorks": "Charged monthly from your balance. Cancel anytime: the number stays yours until the end of the paid month.",
    "preferredState": "Preferred state",
    "anyState": "Any",
    "areaCode": "Area code (optional)",
    "buy": "Get a number for {{price}}/month",
    "balance": "Balance: {{balance}}",
    "balanceHint": "You need {{price}} on your balance to get a number.",
    "unavailable": "SMS numbers are temporarily unavailable. Please check back later.",
    "previousEnded": "Your previous subscription has ended.",
    "endedOn": "Ended on {{date}}.",
    "endReason": {
      "user_canceled": "Your previous subscription ended because renewal was canceled.",
      "insufficient_balance": "Your previous subscription ended because the balance did not cover the renewal.",
      "provisioning_failed": "The last order could not be completed; the payment was refunded.",
      "admin": "Your previous subscription was ended by support."
    },
    "status": {
      "provisioning": "Setting up",
      "active": "Active",
      "canceled": "Renewal canceled"
    },
    "provisioningHint": "Usually takes a moment, sometimes up to 20 minutes. This page updates automatically; if the order fails, the payment is refunded.",
    "renewsOn": "Renews on {{date}} for {{price}}.",
    "endsOn": "The number stays yours until {{date}}.",
    "renewalWillFail": "Your balance is negative, so the renewal on {{date}} will fail and the number will be released.",
    "cancelRenewal": "Cancel renewal",
    "resumeRenewal": "Resume renewal",
    "resumeUnavailable": "Renewal cannot be resumed while SMS numbers are unavailable.",
    "copyNumber": "Copy number",
    "loadFailed": "Could not load your SMS number.",
    "retry": "Retry",
    "failure": {
      "shortfall": "Not enough funds: add {{amount}} to continue.",
      "invalid_region": "Choose a US state from the list and a 3-digit area code.",
      "no_numbers_available": "No numbers are available for this region right now. Try another state or area code.",
      "order_failed": "The number could not be ordered. The payment was refunded."
    },
    "messages": {
      "title": "Messages",
      "subtitle": "Incoming texts to your number, newest first.",
      "total": "Total: {{count}}",
      "refresh": "Refresh",
      "empty": "No messages yet. Texts sent to your number appear here within a minute.",
      "loadFailed": "Could not load messages.",
      "to": "to {{number}}",
      "copyCode": "Copy code"
    }
  },
  "shopify": {
    "items": "Items",
    "profiles": "Profiles",
    "createProfile": "Create Profile",
    "editProfile": "Edit Profile",
    "viewProfile": "Profile Details",
    "storeName": "Store Name",
    "apiSecretKey": "API Secret Key",
    "adminApiAccessToken": "Admin API Access Token",
    "locationId": "Location ID",
    "deleteProfile": "Delete Profile",
    "deleteConfirmation": "Are you sure you want to delete this profile?",
    "itemId": "Item ID",
    "state": "State",
    "addItem": "Add Item",
    "noProfiles": "No Shopify profiles found",
    "noItems": "No items found",
    "exportToShopify": "Export to Shopify",
    "exportDescription": "Export this inventory item to your Shopify store. The item will be synced with your selected Shopify profile.",
    "selectProfile": "Select Shopify Profile",
    "requestExport": "Request Shopify Export",
    "exportSuccess": "Item successfully queued for Shopify export",
    "noProfilesAvailable": "No Shopify profiles available. Please create a profile first.",
    "alreadyExported": "This item has already been exported to Shopify.",
    "states": {
      "exporting": "Pending",
      "exported": "Exported"
    }
  },
  "support": {
    "useSidebar": "Click the chat bubble in the sidebar to reach our support team.",
    "unavailableImpersonation": "Support chat is unavailable during impersonation."
  },
  "expectedParcel": {
    "expectedParcelTitle": "Expected Parcel",
    "trackingNumber": "Tracking number (optional)",
    "noTrackingNumber": "No tracking number",
    "orderNumber": "Order number",
    "storeName": "Store name",
    "customerComment": "Comment"
  }
}
